import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LangService } from '../../../controller/lang-service';

@Component({
  selector: 'app-why-choose-us',
  imports: [TranslateModule, CommonModule],
  templateUrl: './why-choose-us.html',
  styleUrl: './why-choose-us.css'
})
export class WhyChooseUs {

    lang = inject(LangService);


  features = [
  { icon: '⚡', title: 'why.features.fast', desc: 'why.descriptions.fast' },
  { icon: '🧠', title: 'why.features.smart', desc: 'why.descriptions.smart' },
  { icon: '🛠️', title: 'why.features.nocode', desc: 'why.descriptions.nocode' },
  { icon: '🌍', title: 'why.features.i18n', desc: 'why.descriptions.i18n' },
  { icon: '🔌', title: 'why.features.protocols', desc: 'why.descriptions.protocols' },
  { icon: '📱', title: 'why.features.mobile', desc: 'why.descriptions.mobile' }
];


}
